import GenericModel from 'js/models/generic.model';

require('moment');

export default GenericModel.extend({
    urlRoot: '/CampaignCloud/ApiUser',
    idAttribute: 'id',
    defaults: {
        description: "",
        apiKey: "",
        totalRedemptions: null, //counter
        status: null, //active-inactive
        email: ""
    }
});
